import styled from 'styled-components';
import { Layout } from 'antd';
import { EditorHeader } from '../../modules/editor/editor.style';
const { Header, Footer, Content } = Layout;
export const LayoutOuter = styled(Layout) `
  background: hsl(0 0% 95% / 1);
  background-color: hsl(0, 0%, 95%, 1);
`;
export const LayoutContent = styled(Content) `
  background: hsl(0 0% 95% / 1);
  background-color: hsl(0 0% 95% / 1);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
`;
export const LayoutContentInner = styled.div `
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* margin: auto; */
  position: relative;
  width: 100%;
  height: 100%;
  & > * {
    z-index: 1;
  }
`;
export const PageContent = styled.div `
  display: flex;
  justify-content: center;
  align-items: flex-start;
  ${({ center }) => center && 'margin: auto;'}
  ${({ center }) => !center && 'height: 100%;'}
  position: relative;
  width: 100%;
`;
export const NavBar = styled(Header) `
  display: flex;
  align-items: center;
  padding: 0;
  border-bottom: none;
  background-color: #fff;
  background: #fff;
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.07);

  ${EditorHeader} {
    border-bottom: none;
  }
`;
export const PageContentWrapper = styled.div `
  /* padding: calc(calc(5 * 1px) * 4) calc(calc(5 * 1px) * 2); */
  max-width: ${({ width }) => (typeof width === 'number' ? `${width}px` : '100%')};
  width: 100%;
  height: 100%;
`;
export const PageContentHeader = styled.div `
  padding: 0 0 calc(5 * 2px);
  display: block;
  position: relative;
  & > h1 {
    font-size: calc(calc(14px - 2px) * 2);
    font-weight: 600;
    color: hsla(0, 0%, 33.33%, 1);
    margin: 0;
  }
  & > p {
    font-size: 14px;
    line-height: normal;
    color: hsla(0, 0%, 33.33%, 1);
    margin: calc(calc(5 * 1px) * 1) 0 calc(calc(5 * 1px) * 2);
  }
`;
